import axios from "axios";

// let baseUrl = "https://0g01d8wd-5000.inc1.devtunnels.ms/api/";
export let baseUrl = "https://loba-backend-0521f536409e.herokuapp.com/api/";

const api = async (path, params, method) => {
  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${resultttt}`,
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
